
import { ContentSuggestion } from './types';

export const MOCK_SUGGESTIONS: ContentSuggestion[] = [
  {
    id: '1',
    title: 'Studio Session Breakdown',
    description: 'Record a quick TikTok showing your production process for your latest track. Focus on one interesting sound design technique.',
    platform: 'tiktok',
    engagement: 92,
    isNew: true,
    trend: 'viral',
    type: 'tutorial',
    hashtags: ['musicproduction', 'homestudio', 'behindthescenes', 'producertips']
  },
  {
    id: '2',
    title: 'Transition Challenge',
    description: 'Create a video using the viral transition effect where you change outfits/locations to the beat drop of your song.',
    platform: 'instagram',
    engagement: 87,
    isNew: true,
    trend: 'rising',
    type: 'challenge',
    hashtags: ['transitionchallenge', 'outfitchange', 'beatdrop', 'musicchallenge']
  },
  {
    id: '3',
    title: '"Tell Me Without Telling Me" Format',
    description: 'Create a "Tell me you\'re a [your genre] artist without telling me" video highlighting quirky aspects of your music style.',
    platform: 'tiktok',
    engagement: 78,
    isNew: false,
    trend: 'steady',
    type: 'meme',
    hashtags: ['tellmewithouttellingme', 'musicianlife', 'musicianproblems', 'artistlife']
  },
  {
    id: '4',
    title: 'Day In The Life',
    description: 'Document a day in your life as an artist - from morning routine to studio session. Fans love behind-the-scenes content.',
    platform: 'youtube',
    engagement: 81,
    isNew: false,
    trend: 'rising',
    type: 'story',
    hashtags: ['dayinthelife', 'musicianvlog', 'artistroutine', 'behindthescenes']
  },
  {
    id: '5',
    title: 'Music Industry Hot Take',
    description: 'Share a controversial opinion or hot take about the music industry in a Twitter thread. Generate discussion and visibility.',
    platform: 'twitter',
    engagement: 74,
    isNew: true,
    trend: 'rising',
    type: 'story',
    hashtags: ['musicindustry', 'hottake', 'indieartist', 'musicbusiness']
  },
];
